var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullframe"},[_c('img',{staticClass:"center",attrs:{"src":"/img/not_found.jpg","width":"500px","alt":"not_found"}})])}]

export { render, staticRenderFns }